
import React, { useState } from "react";
import SimpleBar from 'simplebar-react';
import { useLocation } from "react-router-dom";
import { CSSTransition } from 'react-transition-group';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faUsers, faProjectDiagram, faBoxOpen, faBuilding, faGavel, faChartBar,
  faUserFriends, faChartPie, faBullseye, faMoneyBillWave, faCrosshairs,
  faHandshake, faStore, faHardHat, faUserTie, faTruck, faTools, faDollarSign,
  faBalanceScale, faWarehouse, faLayerGroup, faWater, faBriefcase,
  faGlobe, faIndustry, faUsersCog, faFileInvoiceDollar, faFileSignature,
  faStar, faCog, faUserShield, faBoxes, faCreditCard, faPercentage,
  faCalculator, faTimes, faSearch, faSignOutAlt, faChevronDown, faReceipt,
  faHandHoldingUsd, faFileAlt, faChartLine, faFilePdf
} from "@fortawesome/free-solid-svg-icons";
import { Nav, Badge, Image, Button, Accordion, Navbar, Form, InputGroup } from '@themesberg/react-bootstrap';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { performLogout } from "../redux/authSlice";

import { Routes } from "../routes";
import ReactHero from "../assets/img/technologies/react-hero-logo.svg";
import ProfilePicture from "../assets/img/team/profile-picture-3.jpg";

export default (props = {}) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const { pathname } = location;
  const [show, setShow] = useState(false);
  const showClass = show ? "show" : "";
  const [searchQuery, setSearchQuery] = useState("");
  const { roles } = useSelector(state => state.auth);

  const onCollapse = () => setShow(!show);

  const matchesSearch = (text) => {
    if (!searchQuery.trim()) return true;
    return text.toLowerCase().includes(searchQuery.toLowerCase());
  };

  // Collapsable always open by default (defaultActiveKey = eventKey)
  const CollapsableNavItem = ({ eventKey, title, icon, children = null }) => {
    const groupMatchesSearch = (text) => {
      if (!searchQuery.trim()) return true;
      return text.toLowerCase().includes(searchQuery.toLowerCase());
    };

    return (
      <Accordion as={Nav.Item} defaultActiveKey={eventKey}>
        <Accordion.Item eventKey={eventKey}>
          <Accordion.Button as={Nav.Link} className="d-flex justify-content-between align-items-center">
            <span>
              <span className="sidebar-icon"><FontAwesomeIcon icon={icon} /> </span>
              <span className="sidebar-text">{title}</span>
            </span>
          </Accordion.Button>
          <Accordion.Body className="multi-level">
            <Nav className="flex-column">
              {children}
            </Nav>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    );
  };

  const NavItem = ({ title, link, external, target, icon, badgeText, badgeBg = "secondary", badgeColor = "primary" }) => {
    const classNames = badgeText ? "d-flex justify-content-start align-items-center justify-content-between" : "";
    const navItemClassName = link === pathname ? "active" : "";
    const linkProps = external ? { href: link } : { as: Link, to: link };

    return (
      <Nav.Item className={navItemClassName} onClick={() => setShow(false)}>
        <Nav.Link {...linkProps} target={target} className={classNames}>
          <span>
            {icon ? <span className="sidebar-icon"><FontAwesomeIcon icon={icon} /> </span> : null}
            <span className="sidebar-text">{title}</span>
          </span>
          {badgeText ? (
            <Badge pill bg={badgeBg} text={badgeColor} className="badge-md notification-count ms-2">{badgeText}</Badge>
          ) : null}
        </Nav.Link>
      </Nav.Item>
    );
  };

  return (
    <>
      <Navbar expand={false} collapseOnSelect variant="dark" className="navbar-theme-primary px-4 d-md-none">
        <Navbar.Brand className="me-lg-5" as={Link} to={Routes.DashboardOverview.path}>
          <Image src={ReactHero} className="navbar-brand-light" />
        </Navbar.Brand>
        <Navbar.Toggle as={Button} aria-controls="main-navbar" onClick={onCollapse}>
          <span className="navbar-toggler-icon" />
        </Navbar.Toggle>
      </Navbar>

      <CSSTransition timeout={300} in={show} classNames="sidebar-transition">
        <SimpleBar className={`collapse ${showClass} sidebar d-md-block bg-primary text-white`}>
          <div className="sidebar-inner px-4 pt-3">

            {/* Brand */}
            <div className="user-card d-flex d-md-none align-items-center justify-content-between justify-content-md-center pb-4">
              <div className="d-flex align-items-center">
                <div className="user-avatar lg-avatar me-4">
                  <Image src={ProfilePicture} className="card-img-top rounded-circle border-white" />
                </div>
                <div className="d-block">
                  <h6>Hi, Jane</h6>
                  <Button variant="secondary" size="xs" onClick={() => dispatch(performLogout())} className="text-dark">
                    <FontAwesomeIcon icon={faSignOutAlt} className="me-2" /> Sign Out
                  </Button>
                </div>
              </div>
              <Nav.Link className="collapse-close d-md-none" onClick={onCollapse}>
                <FontAwesomeIcon icon={faTimes} />
              </Nav.Link>
            </div>

            <Nav className="flex-column pt-3 pt-md-0">

              {/* Logo / Title */}
              <div className="d-block mb-3 text-center">
                <div className="d-flex align-items-center justify-content-center">
                  <div style={{
                    width: '35px', height: '35px', backgroundColor: 'white',
                    borderRadius: '50%', display: 'flex', alignItems: 'center',
                    justifyContent: 'center', marginRight: '10px'
                  }}>
                    <span style={{ color: '#0948B3', fontWeight: 'bold', fontSize: '20px' }}>P</span>
                  </div>
                  <span className="fw-bold h5 text-white mb-0">Productivos</span>
                </div>
              </div>

              {/* Search Bar */}
              <div className="mb-3">
                <InputGroup>
                  <InputGroup.Text>
                    <FontAwesomeIcon icon={faSearch} />
                  </InputGroup.Text>
                  <Form.Control
                    type="text"
                    placeholder="Buscar en el menú..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                </InputGroup>
              </div>

              {/* Admin items - always first */}
              {roles && roles.includes('ROLE_ADMIN') && (matchesSearch('Administracion') || matchesSearch('Dashboard Usuarios')) && (
                <CollapsableNavItem eventKey="admin-dashboard/" title="Administracion" icon={faUserShield}>
                  {matchesSearch('Administracion') && (
                    <NavItem title="Administracion" link={Routes.AdminDashboard.path} icon={faUserShield} />
                  )}
                  {matchesSearch('Dashboard Usuarios') && (
                    <NavItem title="Dashboard Usuarios" link={Routes.UserStatsDashboard.path} icon={faChartBar} />
                  )}
                  {matchesSearch('Dashboard Ideas de Negocio') && (
                    <NavItem title="Dashboard Ideas de Negocio" link={Routes.CiemStatsDashboard.path} icon={faChartBar} />
                  )}
                </CollapsableNavItem>
              )}

              {/* Configuración (admin only) */}
              {roles && roles.includes('ROLE_ADMIN') && (matchesSearch('Configuración') || matchesSearch('Opciones') || matchesSearch('Administración de usuarios')) && (
                <CollapsableNavItem eventKey="configuration/" title="Configuración" icon={faCog}>
                  {matchesSearch('Listado Opciones') && (
                    <NavItem title="Listado Opciones (Todos)" link={Routes.ListDetailOptionPage.path} icon={faLayerGroup} />
                  )}
                  {matchesSearch('Opciones') && (
                    <NavItem title="Opciones" link={Routes.DetailOptionPage.path.replace(':id', '102')} icon={faBoxOpen} />
                  )}
                  {matchesSearch('Administración de usuarios') && (
                    <NavItem title="Administración de usuarios" link={Routes.UserAdministrationPage.path} icon={faUserShield} />
                  )}
                </CollapsableNavItem>
              )}

              {/* 1. Equipo Emprendedor */}
              {matchesSearch('Equipo Emprendedor') && (
                <NavItem title="1. Equipo Emprendedor" link={Routes.ListTeamPage.path} icon={faUsers} />
              )}

              {/* 2. Título del proyecto */}
              {matchesSearch('Título del proyecto') && (
                <NavItem title="2. Título del proyecto" link={Routes.ListCiemPage.path} icon={faProjectDiagram} />
              )}

              {/* 3. El producto (with sublevels) */}
              {(matchesSearch('El producto') || matchesSearch('Descripción del producto') || matchesSearch('Representación gráfica') || matchesSearch('Código CIIU')) && (
                <CollapsableNavItem eventKey="producto/" title="3. El producto" icon={faBoxOpen}>
                  {matchesSearch('Descripción del producto') && (
                    <NavItem title="3.1 Descripción del producto" link={Routes.ListProductPage.path} icon={faBoxOpen} />
                  )}
                  {matchesSearch('Representación gráfica') && (
                    <NavItem title="3.2 Representación gráfica del producto" link={Routes.RepresentacionGraficaPage.path} icon={faChartPie} />
                  )}
                  {matchesSearch('Código CIIU') && (
                    <NavItem title="3.3 Código CIIU" link={Routes.ListProductPage.path} icon={faBoxes} />
                  )}
                </CollapsableNavItem>
              )}

              {/* 4. Empresa nueva o a reorganizar */}
              {matchesSearch('Empresa nueva') && (
                <NavItem title="4. Empresa nueva o a reorganizar" link={Routes.LegalPage.path} icon={faBuilding} />
              )}

              {/* 5. Marco legal */}
              {matchesSearch('Marco legal') && (
                <NavItem title="5. Marco legal" link={Routes.LegalPage.path} icon={faGavel} />
              )}

              {/* 6. Margen de Contribución */}
              {matchesSearch('Margen de Contribución') && (
                <NavItem title="6. Margen de Contribución" link={Routes.ContributionPage.path} icon={faChartBar} />
              )}

              {/* 7. Clientes (with sublevels) */}
              {(matchesSearch('Clientes') || matchesSearch('Mercado potencial') || matchesSearch('Perfil del mercado') || matchesSearch('Valor mercado potencial') || matchesSearch('Valor mercado objetivo') || matchesSearch('Competidores') || matchesSearch('Participación en el mercado')) && (
                <CollapsableNavItem eventKey="clientes/" title="7. Clientes" icon={faUserFriends}>
                  {matchesSearch('Mercado potencial') && (
                    <NavItem title="Mercado potencial" link={Routes.MercadoPotencialPage.path} icon={faBullseye} />
                  )}
                  {matchesSearch('Perfil del mercado') && (
                    <NavItem title="Perfil del mercado" link={Routes.PerfilMercadoPage.path} icon={faUserTie} />
                  )}
                  {matchesSearch('Valor mercado potencial') && (
                    <NavItem title="Valor mercado potencial" link={Routes.MercadoPage.path} icon={faMoneyBillWave} />
                  )}
                  {matchesSearch('Valor mercado objetivo') && (
                    <NavItem title="Valor mercado objetivo" link={Routes.MercadoObjetivoPage.path} icon={faCrosshairs} />
                  )}
                  {matchesSearch('Competidores') && (
                    <NavItem title="Competidores" link={Routes.CompetitorPage.path} icon={faHandshake} />
                  )}
                  {matchesSearch('Participación en el mercado') && (
                    <NavItem title="Participación en el mercado" link={Routes.MercadoConsumidaPage.path} icon={faStore} />
                  )}
                </CollapsableNavItem>
              )}

              {/* 8. Empleados y costos indirectos (with sublevels) */}
              {(matchesSearch('Empleados') || matchesSearch('Empleados administrativos') || matchesSearch('Empleados Vendedores') || matchesSearch('Mano de obra directa') || matchesSearch('Mano de obra indirecta') || matchesSearch('Costos indirectos')) && (
                <CollapsableNavItem eventKey="empleados/" title="8. Empleados y costos indirectos" icon={faHardHat}>
                  {matchesSearch('Empleados administrativos') && (
                    <NavItem title="Empleados administrativos" link={Routes.EmpleadoPage.path} icon={faUserTie} />
                  )}
                  {matchesSearch('Empleados Vendedores') && (
                    <NavItem title="Empleados Vendedores" link={Routes.EmpleadoVentaPage.path} icon={faTruck} />
                  )}
                  {matchesSearch('Mano de obra directa') && (
                    <NavItem title="Mano de obra directa" link={Routes.EmpleadoDirectoPage.path} icon={faTools} />
                  )}
                  {matchesSearch('Mano de obra indirecta') && (
                    <NavItem title="Mano de obra indirecta" link={Routes.EmpleadoIndirectoPage.path} icon={faTools} />
                  )}
                  {matchesSearch('Costos indirectos') && (
                    <NavItem title="Costos indirectos" link={Routes.CostosFijosMensualPage.path} icon={faDollarSign} />
                  )}
                </CollapsableNavItem>
              )}

              {/* 9. Punto de equilibrio */}
              {matchesSearch('Punto de equilibrio') && (
                <NavItem title="9. Punto de equilibrio" link={Routes.PeuPage.path} icon={faBalanceScale} />
              )}

              {/* 10. Capacidad instalada */}
              {matchesSearch('Capacidad instalada') && (
                <NavItem title="10. Capacidad instalada" link={Routes.CapacidadInstaladaPage.path} icon={faWarehouse} />
              )}

              {/* 11. Inversiones (with sublevels) */}
              {(matchesSearch('Inversiones') || matchesSearch('Capital de trabajo')) && (
                <CollapsableNavItem eventKey="inversiones/" title="11. Inversiones" icon={faLayerGroup}>
                  {matchesSearch('Capital de trabajo') && (
                    <NavItem title="12. Capital de trabajo" link={Routes.InversionCapitalTrabajoPage.path} icon={faWater} />
                  )}
                </CollapsableNavItem>
              )}

              {/* 13. Financiación (with sublevels) */}
              {(matchesSearch('Financiación') || matchesSearch('Tasa de retorno') || matchesSearch('Costo de capital')) && (
                <CollapsableNavItem eventKey="financiacion/" title="13. Financiación" icon={faBriefcase}>
                  {matchesSearch('Tasa de retorno') && (
                    <NavItem title="14. Tasa de retorno" link={Routes.TasaRetornoPage.path} icon={faChartLine} />
                  )}
                  {matchesSearch('Costo de capital') && (
                    <NavItem title="15. Costo de capital" link={Routes.CalculoCostoCapitalPage.path} icon={faCalculator} />
                  )}
                </CollapsableNavItem>
              )}

              {/* 16. Sector externo */}
              {matchesSearch('Sector externo') && (
                <NavItem title="16. Sector externo" link={Routes.SectorExternoPage.path} icon={faGlobe} />
              )}

              {/* 17. Estructura producción */}
              {matchesSearch('Estructura producción') && (
                <NavItem title="17. Estructura producción" link={Routes.EstructuraProduccionPage.path} icon={faIndustry} />
              )}

              {/* 18. Inversores (with sublevels) */}
              {(matchesSearch('Inversores') || matchesSearch('Gastos') || matchesSearch('Plan de Negocio')) && (
                <CollapsableNavItem eventKey="inversores/" title="18. Inversores" icon={faUsersCog}>
                  {matchesSearch('Gastos') && (
                    <NavItem title="19. Gastos" link={Routes.GastosPage.path} icon={faReceipt} />
                  )}
                  {matchesSearch('Plan de Negocio') && (
                    <NavItem title="20. Plan de Negocio" link={Routes.PlanDeNegocioPage.path} icon={faFileAlt} />
                  )}
                </CollapsableNavItem>
              )}

              {/* 21. Estado de Resultados */}
              {matchesSearch('Estado de Resultados') && (
                <NavItem title="21. Estado de Resultados" link={Routes.EstadoResultadosPage.path} icon={faFileInvoiceDollar} />
              )}

              {matchesSearch('Carta de intención') && (
                <NavItem title="22. Carta de intención" link={Routes.CartaIntencionPage.path} icon={faFileSignature} />
              )}

              {/* Reporte PDF */}
              {matchesSearch('Reporte PDF') && (
                <NavItem title="Reporte PDF" link={Routes.ReportePdfPage.path} icon={faFilePdf} />
              )}

              {/* 23. Calificación */}
              {matchesSearch('Calificación') && (
                <NavItem title="23. Calificación" link={Routes.BusinessModelRatingPage.path} icon={faStar} />
              )}


            </Nav>
          </div>
        </SimpleBar>
      </CSSTransition>
    </>
  );
};
